import {
  LANGUAGE_CODES, 
  LanguageCode, 
  getTranslation, 
  updateTranslation 
} from '../i18n/i18n'

export interface Food {
  id: number
  name?: string                    // 日本語名
  thumbnailImageFileName?: string
  thumbnailImageURL?: string
  index?: number
  foodTranslations?: FoodTranslation[]  // 多言語翻訳データ
  price?: number
  brand_code?: string              // ブランドコード（admin権限のみ有効）
}

export interface FoodTranslation {
  langCode: string                // 言語コード
  name: string                    
}

export enum FoodImageType {
  ThumbnailImage = 'thumbnail_image',
}

export interface FoodImage {
  fileName?: string
  url?: string
  foodImageType?: FoodImageType
}

export const getFoodTranslation = (
  translations: FoodTranslation[] | undefined,
  selectedLanguageCode: LanguageCode
): FoodTranslation | undefined => {
  return getTranslation(translations, selectedLanguageCode)
}

// 翻訳データ作成ヘルパー関数
export const createEmptyFoodTranslations = (): FoodTranslation[] => [
  { langCode: LANGUAGE_CODES.JAPANESE, name: '' },
  { langCode: LANGUAGE_CODES.ENGLISH, name: '' },
]



// FoodTranslation用の更新関数
export const updateFoodTranslation = (
  translations: FoodTranslation[] | undefined,
  langCode: string,
  name: string
): FoodTranslation[] => {
  const currentTranslations = translations || []
  return updateTranslation(currentTranslations, langCode, { name })
}
